
import Vue from "vue";
import { PAGE_EXPLANATIONS } from "./pageExplanations";

export default Vue.extend({
  name: "PageExplanation",
  props: {
    pageKey: { type: String, required: true }
  },
  computed: {
    explanation(): string {
      return PAGE_EXPLANATIONS[this.pageKey] || "";
    }
  }
});
